import { useCallback, useContext, useMemo, useState } from 'react';
import * as Cookie from 'js-cookie';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks/useFlag';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { isPWA } from '../utils/isPWA';
import { useAction } from '@wix/da-hooks/pkg/useAction';
import { registerPushSubscription } from '../redux/pwa/actions';
export const COOKIE_NAME = 'pwae';
export function usePWABanner() {
    const isFlagEnabled = useFlag('pwa');
    const isMobile = useContext(MobileContext);
    const registerPush = useAction(registerPushSubscription);
    const cookieValue = Cookie.get(COOKIE_NAME);
    const [isDismissed, setIsDismissed] = useState(cookieValue === '1');
    // dismiss for 30 days
    const dismiss = useCallback(()=>{
        Cookie.set(COOKIE_NAME, '1', {
            expires: 30
        });
        setIsDismissed(true);
    }, []);
    const isStandalone = useMemo(()=>isPWA(), []);
    return {
        isHidden: !isMobile || !isFlagEnabled || !isStandalone || isDismissed,
        dismiss,
        registerPushSubscription: registerPush
    };
}

//# sourceMappingURL=usePWABanner.js.map